import { NgModule } from '@angular/core';
import {
    CmpsButtonModule,
    CmpsIconModule,
    CmpsTooltipModule,
} from '@cmps/ng-uikit';

import { CmpsLazyI18nModule } from '../../../i18n/i18n.module';
import { CmpsCoachingBlDialogModule } from '../dialog';

import { BlButtonComponent } from './bl-button.component';
import { TranslationIdMap } from './bl-button.i18n';

@NgModule({
    declarations: [BlButtonComponent],
    exports: [BlButtonComponent],
    imports: [
        CmpsButtonModule,
        CmpsCoachingBlDialogModule,
        CmpsIconModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CmpsTooltipModule,
    ],
})
export class CmpCoachingBlButtonModule {}
